export const RHP_EDITOR_ID = 'rhp-ckeditor-instance';
